import * as React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { LogOut } from "lucide-react";
import * as analytics from "@/services/analytics";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import { Loader } from "@/components/ui/loader";

export const EsgLayout: React.FC = () => {
  const location = useLocation();
  const authenticatedUser = useAuthenticatedUser();
  const loginPath = React.useMemo(() => {
    const redirectPath = `${location.pathname}${location.search}`;
    return `/login?state=${encodeURIComponent(btoa(redirectPath))}`;
  }, [location.pathname, location.search]);

  const isResolvingAuth =
    authenticatedUser.isLoading || (authenticatedUser.isFetching && !authenticatedUser.isAuthenticated);

  if (isResolvingAuth) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader className="h-8 w-8 text-coral" />
      </div>
    );
  }

  if (!authenticatedUser.isAuthenticated) {
    return <Navigate to={loginPath} replace />;
  }

  if (!authenticatedUser.organization.features.includes("esg_portal")) {
    return <Navigate to="/" replace />;
  }

  const handleLogout = () => {
    analytics.logout();
  };

  return (
    <div className="flex h-screen flex-col bg-[#f1ede9]">
      <main className="flex flex-grow flex-col overflow-auto">
        <Outlet />
      </main>
      <footer className="flex h-14 shrink-0 items-center justify-end border-t border-[#e1ddd6] bg-[#f1ede9]/90 px-6 backdrop-blur-sm">
        <a
          href="/pf-auth/logout"
          onClick={handleLogout}
          className="flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900"
        >
          <LogOut size={16} />
          <span>Logout</span>
        </a>
      </footer>
    </div>
  );
};
